<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Leave a Donation</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->

  <div #questionContainer class="card-body" style="">
    <div class="participant-list">
      <div>
        <form #theForm="ngForm">
          <div *ngIf="errorMessage" class="alert alert-primary" role="alert">
            {{ errorMessage }}
          </div>
          <div class="form-row mb-2">
            <div class="col-md-12 text-center">
              <ul class="nav nav-pills nav-fill">
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 1 }" (click)="tipAmount = 1" href="javascript:void(0)">$1</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 5 }" (click)="tipAmount = 5" href="javascript:void(0)">$5</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 10 }" (click)="tipAmount = 10" href="javascript:void(0)">$10</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 20 }" (click)="tipAmount = 20" href="javascript:void(0)">$20</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 25 }" (click)="tipAmount = 25" href="javascript:void(0)">$25</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 50 }" (click)="tipAmount = 50" href="javascript:void(0)">$50</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: tipAmount == 100 }" (click)="tipAmount = 100" href="javascript:void(0)">$100</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-12 mb-2">
              <label for="uname1">Card Number</label>
              <input type="text" class="form-control" [(ngModel)]="cardNumber" name="cardNumber" required creditcard placeholder="Card Number" />
              <div class="invalid-message">
                <div>Card Number is required</div>
              </div>
            </div>
            <div class="col-5">
              <label for="uname1">Month</label>
              <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
                <option value="1">01 - January</option>
                <option value="2">02 - February</option>
                <option value="3">03 - March</option>
                <option value="4">04 - April</option>
                <option value="5">05 - May</option>
                <option value="6">06 - June</option>
                <option value="7">07 - July</option>
                <option value="8">08 - August</option>
                <option value="9">09 - September</option>
                <option value="10">10 - October</option>
                <option value="11">11 - November</option>
                <option value="12">12 - December</option>
              </select>
              <div class="invalid-message">
                <div>Month is required</div>
              </div>
            </div>
            <div class="col-5">
              <label for="uname1">Year</label>
              <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
              </select>
              <div class="invalid-message">
                <div>Year is required</div>
              </div>
            </div>
            <div class="col-2">
              <label for="uname1">CVV</label>
              <input type="text" class="form-control" [(ngModel)]="cvv" name="cvv" placeholder="CVV" required />
              <div class="invalid-message">
                <div>CVV is required</div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12">
              <button type="button" class="form-control btn btn-success" [promiseBtn]="submitComplete" (click)="sendTip()">Send</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
